import { gql } from '@apollo/client'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import { useServiceOrder } from './ServiceOrderLoader'

const Context = React.createContext([])
const { Provider } = Context
export const useBrotherServiceOrderState = () => React.useContext(Context)
export const useBrotherServiceOrder = () => useBrotherServiceOrderState()?.serviceOrders || []

const QUERY = gql`
  query ServiceOrders($filter: ServiceOrderFilter) {
    serviceOrders(filter: $filter) {
      id
      yearlyId
      startDate
      endDate
      deleted
      insertedAt
      updatedAt
      checklist {
        id
        name
      }
      address {
        search
        complement
      }
      fieldValues {
        id
        value
        fieldId
        field {
          id
          name
          type
        }
      }
      user {
        id
        name
        fieldValues {
          id
          value
          field {
            id
            name
          }
        }
      }
      placeId
      place {
        id
        name
        resume
        placeLevelsResume
        fieldValues {
          id
          value
          field {
            id
            name
          }
        }
      }
      replies {
        id
        value
        notes
        questionId
        insertedAt
        blockIndex
        documents {
          id
          src
          type
          description
        }
        question {
          id
          name
          data
          ordination
          categoryOrdination
          reference
          parentReference
          description
          documents {
            id
            src
            type
            description
          }
          type {
            id
            name
          }
          category {
            id
            name
          }
        }
      }
    }
  }
`

const ParentServiceOrderLoader = ({ children }) => {
  const serviceOrder = useServiceOrder()
  const filter = {}
  let skip = true

  if (serviceOrder.checklist.id === 608) {
    skip = true
  } else {
    filter.directParentIds = [serviceOrder.parentId]
    skip = false
    filter.checklistIds = [608]
  }
  let { data, ...state } = useQuery(QUERY, {
    variables: { filter },
    client: serviceOrdersClient,
    skip
  })

  return (
    <StatePresenter {...state} noEmptyMessage>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ParentServiceOrderLoader
